export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7911.2158eb11.jpg";